import * as React from "react";
import { Check, Minus } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
const comparisons = [{
  feature: "Patient Comfort",
  traditional: "Bulky mask and restrictive tubing",
  smilecraft: "Custom-fit, discreet mouthpiece"
}, {
  feature: "Portability",
  traditional: "Requires power and extra luggage",
  smilecraft: "Fits in a pocket, no power needed"
}, {
  feature: "Noise Level",
  traditional: "Constant machine hum and air leaks",
  smilecraft: "Completely silent operation"
}, {
  feature: "Ease of Use",
  traditional: "Complex setup and nightly cleaning",
  smilecraft: "Simple to wear and easy to maintain"
}, {
  feature: "Compliance Rates",
  traditional: "Often abandoned due to intolerance",
  smilecraft: "High patient adherence and success"
}];
export default function ANewStandard() {
  return <section data-section-id="153012" id="therapy-options" className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-[900px] px-6 lg:px-8">
        <div className="mb-16 text-center">
          <h2 className="text-foreground text-3xl font-bold tracking-tight sm:text-4xl">
            Comparing Your Treatment Options
          </h2>
          <p className="text-muted-foreground mt-4 text-lg">
            Understand the key differences between traditional CPAP machines and modern oral appliance therapy.
          </p>
        </div>

        <div className="overflow-hidden rounded-xl border border-border/50 bg-card shadow-md">
          <Table>
            <TableHeader className="bg-secondary/50">
              <TableRow className="hover:bg-transparent">
                <TableHead className="w-[30%] py-5 text-sm font-medium uppercase tracking-wider text-muted-foreground">
                  Feature
                </TableHead>
                <TableHead className="w-[35%] py-5 text-sm font-medium uppercase tracking-wider text-muted-foreground">
                  Traditional CPAP
                </TableHead>
                <TableHead className="w-[35%] py-5 text-sm font-bold uppercase tracking-wider text-primary">
                  Oral Appliances
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {comparisons.map((item, i) => <TableRow key={i} data-index={i} className="border-border/50 hover:bg-secondary/20 transition-colors">
                  <TableCell className="py-6 font-medium text-foreground">
                    {item.feature}
                  </TableCell>
                  <TableCell className="py-6 text-muted-foreground">
                    <div className="flex items-center gap-3">
                      <Minus className="h-4 w-4 shrink-0 opacity-50" />
                      <span>{item.traditional}</span>
                    </div>
                  </TableCell>
                  <TableCell className="py-6 font-semibold text-foreground">
                    <div className="flex items-center gap-3">
                      <Check className="text-chart-2 h-5 w-5 shrink-0 stroke-[3]" />
                      <span>{item.smilecraft}</span>
                    </div>
                  </TableCell>
                </TableRow>)}
            </TableBody>
          </Table>
        </div>
      </div>
    </section>;
}